// import { useState } from "react";
import { Menu } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import { Link, NavLink, useLocation } from "react-router-dom";
import logo from "../../assets/images/duepay-logo.svg";

import DashboardIcon from "../../assets/images/side-nav-icons/dashboard-manager.svg";
import ActivesessionIcon from "../../assets/images/side-nav-icons/Active-Session-manager.svg";
import UsermanagerIcon from "../../assets/images/side-nav-icons/User-Manager.svg";
import staffmanagerIcon from "../../assets/images/side-nav-icons/staffManagement.svg";
import analyticsIcon from "../../assets/images/side-nav-icons/analytics.svg";
import bannerIcon from "../../assets/images/side-nav-icons/banner.svg";
import compilanceIcon from "../../assets/images/side-nav-icons/compilance.svg";
import kycIcon from "../../assets/images/side-nav-icons/kyc.svg";
import notificationIcon from "../../assets/images/side-nav-icons/notification.svg";
import permissionIcon from "../../assets/images/side-nav-icons/permission.svg";
import referralIcon from "../../assets/images/side-nav-icons/referral.svg";
import withdrawalIcon from "../../assets/images/side-nav-icons/withdrawal.svg";
import TransactionIcon from "../../assets/images/side-nav-icons/transaction-pamanger.svg";
import EmailTemplateIcon from "../../assets/images/side-nav-icons/emai-mnager.svg";
import ContentIcon from "../../assets/images/side-nav-icons/lab-manager.svg";
import SupportIcon from "../../assets/images/customer-service.png";
import SubscriptionPriceManagerIcon from "../../assets/images/side-nav-icons/subscription-price-manager.svg";
import lang from "../../helper/lang";
import TrustAccountManagerIcon from "../../assets/images/side-nav-icons/trust-account-manager.svg";
import AuditLogsIcon from "../../assets/images/side-nav-icons/auditLogs.svg";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const page = pathname.replace("/", "");

  const menuItems = [
    {
      key: "dashboard",
      label: (
        <NavLink to="/dashboard">
          <span
            className="icon"
            style={{ background: page === "dashboard" ? color : "" }}
          >
            <img src={DashboardIcon} alt="" />
          </span>
          <span className="label">{lang("Dashboard")}</span>
        </NavLink>
      ),
    },
    {
      key: "session",
      label: (
        <NavLink to="/active-session">
          <span
            className="icon"
            style={{ background: page === "session" ? color : "" }}
          >
            <img src={ActivesessionIcon} alt="" />
          </span>
          <span className="label">{lang("Active Session")}</span>
        </NavLink>
      ),
    },
    {
      key: "sub-admin-manager",
      label: (
        <NavLink to="/sub-admin-manager">
          <span
            className="icon"
            style={{ background: page === "sub-admin-manager" ? color : "" }}
          >
            <img src={staffmanagerIcon} alt="" />
          </span>
          <span className="label">Staff Management</span>
        </NavLink>
      ),
    },
    {
      key: "user-manager",
      label: (
        <NavLink to="/user-manager">
          <span
            className="icon"
            style={{ background: page === "user-manager" ? color : "" }}
          >
            <img src={UsermanagerIcon} alt="" />
          </span>
          <span className="label">User Management</span>
        </NavLink>
      ),
    },
    {
      key: "Access Manager",
      label: (
        <NavLink to="/access-manager">
          <span
            className="icon"
            style={{ background: page === "access-manager" ? color : "" }}
          >
            <img src={permissionIcon} alt="" />
          </span>
          <span className="label ellipsis">Roles & Permissions Management</span>
        </NavLink>
      ),
    },
    {
      key: "transaction-manager",
      label: (
        <NavLink to="/transaction-manager">
          <span
            className="icon"
            style={{
              background: page === "transaction-manager" ? color : "",
            }}
          >
            <img src={TransactionIcon} alt="" />
          </span>
          <span className="label">Transactions Manager</span>
        </NavLink>
      ),
    },
    {
      key: "withdrawal-request-manager",
      label: (
        <NavLink to="/withdrawal-request-manager">
          <span
            className="icon"
            style={{
              background: page === "withdrawal-request-manager" ? color : "",
            }}
          >
            <img src={withdrawalIcon} alt="" />
          </span>
          <span className="label ellipsis">Withdrawal Request Manager</span>
        </NavLink>
      ),
    },
    {
      key: "report-manager",
      label: (
        <NavLink to="/report-analytics">
          <span
            className="icon"
            style={{
              background: page === "report-manager" ? color : "",
            }}
          >
            <img src={analyticsIcon} alt="" />
          </span>
          <span className="label">Report Analytics</span>
        </NavLink>
      ),
    },
    {
      key: "kyc-management",
      label: (
        <NavLink to="/kyc-management">
          <span
            className="icon"
            style={{
              background: page === "kyc-management" ? color : "",
            }}
          >
            <img src={kycIcon} alt="" />
          </span>
          <span className="label">KYC/KYB Management</span>
        </NavLink>
      ),
    },
    {
      key: "referral-and-cashback",
      label: (
        <NavLink to="/referral-and-cashback">
          <span
            className="icon"
            style={{
              background: page === "referral-and-cashback" ? color : "",
            }}
          >
            <img src={referralIcon} alt="" />
          </span>
          <span className="label">Referral & Cashback</span>
        </NavLink>
      ),
    },
    {
      key: "banner-management",
      label: (
        <NavLink to="/banner-management">
          <span
            className="icon"
            style={{
              background: page === "banner-management" ? color : "",
            }}
          >
            <img src={bannerIcon} alt="" />
          </span>
          <span className="label">Banner Management</span>
        </NavLink>
      ),
    },
    {
      key: "content-manager",
      label: (
        <NavLink to="/content-manager">
          <span
            className="icon"
            style={{
              background: page === "content-manager" ? color : "",
            }}
          >
            <img src={ContentIcon} alt="" />
          </span>
          <span className="label">Content Manager</span>
        </NavLink>
      ),
    },
    {
      key: "notification-manager",
      label: (
        <NavLink to="/notification-manager">
          <span
            className="icon"
            style={{
              background: page === "notification-manager" ? color : "",
            }}
          >
            <img src={notificationIcon} alt="" />
          </span>
          <span className="label">Notification Manager</span>
        </NavLink>
      ),
    },
    {
      key: "compilance-manager",
      label: (
        <NavLink to="/compliance-manager">
          <span
            className="icon"
            style={{
              background: page === "compliance-manager" ? color : "",
            }}
          >
            <img src={compilanceIcon} alt="" />
          </span>
          <span className="label ellipsis">Compliance & System Manager</span>
        </NavLink>
      ),
    },
    {
      key: "email-template-manager",
      label: (
        <NavLink to="/email-template-manager">
          <span
            className="icon"
            style={{
              background: page === "email-template-manager" ? color : "",
            }}
          >
            <img src={EmailTemplateIcon} alt="" />
          </span>
          <span className="label ellipsis">Email Templates</span>
        </NavLink>
      ),
    },
    {
      key: "trust-account-manager",
      label: (
        <NavLink to="/trust-account-manager">
          <span
            className="icon"
            style={{
              background: page === "trust-account-manager" ? color : "",
            }}
          >
            <img src={TrustAccountManagerIcon} alt="" />
          </span>
          <span className="label">Trust Account Manager</span>
        </NavLink>
      ),
    },
    {
      key: "subscription-price-manager",
      label: (
        <NavLink to="/subscription-price-manager">
          <span
            className="icon"
            style={{
              background: page === "subscription-price-manager" ? color : "",
            }}
          >
            <img src={SubscriptionPriceManagerIcon} alt="" />
          </span>
          <span className="label ellipsis">Subscription Price Manager</span>
        </NavLink>
      ),
    },
    {
      key: "audit-logs-manager",
      label: (
        <NavLink to="/audit-logs-manager">
          <span
            className="icon"
            style={{
              background: page === "audit-logs-manager" ? color : "",
            }}
          >
            <img src={AuditLogsIcon} alt="" className="audit-logs-manager-icon" />
          </span>
          <span className="label">Audit Logs Manager</span>
        </NavLink>
      ),
    },
    {
      key: "invoice-manager",
      label: (
        <NavLink to="/invoice-manager">
          <span
            className="icon"
            style={{
              background: page === "invoice-manager" ? color : "",
            }}
          >
            <MessageOutlined style={{ fontSize: "16px", color: page === "invoice-manager" ? "#fff" : "#1677ff" }} />
          </span>
          <span className="label">Invoice Manager</span>
        </NavLink>
      ),
    },
    {
      key: "support",
      label: (
        <NavLink to="/support">
          <span
            className="icon"
            style={{
              background: page === "support" ? color : "",
            }}
          >
            <img src={SupportIcon} alt="" className="support-icon" />
          </span>
          <span className="label">Support</span>
        </NavLink>
      ),
    },
  ]; return (
    <>
      <div className="brand">
        <Link to="/dashboard" className="main-logo">
          <img src={logo} alt="" />
        </Link>
      </div>
      <hr />
      <Menu
        theme="light"
        mode="inline"
        items={menuItems}
        style={{ borderRight: "none" }}
      />
    </>
  );
}

export default Sidenav;
